// import axios from "axios";
import {axiosInstance} from "./main";

export function getProjets(language) {
    return axiosInstance.get(`/projets`, { params: { language } })
}

export function getProjet(page, language) {
    return axiosInstance.get(`/projets/${page}`, { params: { language } })
}

export function getProjetFile(page, filename, language) {
    return axiosInstance.get(`/projets/${page}/${filename}`, { params: { language } })
}

export function getThemes(language) {
    return axiosInstance.get(`/themes`, { params: { language } })
}

export function getLivres(language) {
    return axiosInstance.get(`/livres`, { params: { language } })
}

export function getLivre(livre, language) {
    return axiosInstance.get(`/livres/${livre}`, { params: { language } })
}

export function getTribunes(language) {
    return axiosInstance.get(`/tribunes`, { params: { language } })
}

export function getTribune(tribune, language) {
    return axiosInstance.get(`/tribunes/${tribune}`, { params: { language } })
}

export function getBiblio() {
    return axiosInstance.get("/bibtex/");
}

export function getSlides(language) {
    return axiosInstance.get("/slides/", { params: { language } });
}

export function getArticles(language) {
    return axiosInstance.get("/articles", { params: { language } });
}

export function getArticle(id, language) {
    return axiosInstance.get(`/articles/${id}`, { params: { language } });
}